import { styled } from '@mui/material'
import { includes } from 'ramda'

export const Container = styled('div', {
  shouldForwardProp: prop => !includes(prop, ['fullWidth', 'footer', 'displaySidebar'])
})(({ fullWidth, footer, displaySidebar }) => ({
  height: `calc(100dvh - 64px - ${footer ? 64 : 0}px)`,
  padding: fullWidth ? '' : '20px 40px',
  overflow: 'auto',
  ...(displaySidebar && {
    '@media (max-width: 480px)': {
      padding: '15px'
    }
  })
}))
